<mat-card>
  <mat-card-content>
    <div class="calendar-header">
      <div class="nav-group">
        <button mat-icon-button (click)="prevMonth()" aria-label="Previous month">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <h2>{{ monthLabel }}</h2>
        <button mat-icon-button (click)="nextMonth()" aria-label="Next month">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <div class="header-actions">
        <button mat-stroked-button (click)="goToday()">Today</button>
        @if (dialogRef) {
          <button mat-icon-button (click)="dialogRef.close()" aria-label="Close calendar">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="legend">
      <span><span class="dot" style="background:#378ADD"></span>Appointment</span>
      <span><span class="dot" style="background:#1D9E75"></span>Telemedicine</span>
      <span><span class="dot" style="background:#D85A30"></span>Event</span>
    </div>

    @if (loading) {
      <div class="loading-row">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    } @else {
      <div class="calendar-grid">
        @for (label of weekdayLabels; track label) {
          <div class="weekday-header">{{ label }}</div>
        }

        @for (week of weeks; track $index) {
          @for (cell of week; track cell.date.toISOString()) {
            <div
              class="day-cell"
              [class.outside-month]="!cell.inCurrentMonth"
              [class.today]="cell.isToday"
              (click)="openDay(cell)">
              <span class="day-number">{{ cell.date | date:'d' }}</span>
              @if (cell.activities.length) {
                <div class="dots">
                  @for (activity of cell.activities.slice(0, 4); track activity.id) {
                    <span class="dot" [style.background]="dotColorFor(activity.type)"></span>
                  }
                  @if (cell.activities.length > 4) {
                    <span class="more-count">+{{ cell.activities.length - 4 }}</span>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    }
  </mat-card-content>
</mat-card>
